import React from "react"

function IconChevronDown({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="chevron-down"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-chevron-down"
      {...props}
    >
      <path
        d="M20.1 9.844a.655.655 0 0 0-.835-1.002l-.091.076L12 16.094 4.827 8.918a.655.655 0 0 0-.835-.076l-.09.076a.655.655 0 0 0-.076.835l.075.09 7.636 7.638c.227.227.58.252.835.076l.09-.076L20.1 9.844z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconChevronDown
